import {
    createPageMetricsForResponse,
    PageType,
} from '@jet-app/music-classical/metrics/page';
import { ObjectGraph } from '@jet/environment/dependencies';

import { type BrowsePage, type PageHeader, type PageKind } from '../../models';
import type { ClassicalAPIResponse } from '../../api/types';
import { transformSections } from '../../utilities/transforms/sections';
import type { Tab } from '@jet-app/music-classical/models/header';
import { makeBrowsePageIntent } from './BrowsePageIntent';
import { Bag } from '../../dependencies/bag';
import { createFlowAction } from '../../utilities/create-flow-action';
import { addingBrowseSeoData } from '@jet-app/music-classical/utilities/seo/Browse';

export function renderBrowsePage(
    canonicalURL: string,
    apiResponse: ClassicalAPIResponse,
    intentTab: string,
    objectGraph: ObjectGraph,
): BrowsePage {
    const responseHeader = apiResponse?.body?.header as unknown as PageHeader;
    const tabs = responseHeader?.tabs as unknown as Tab[];
    const countryCode = Bag.countryCode(objectGraph);
    const page = {
        pageKind: 'componentScreen' as PageKind, // we know browse page response comes as componentScreen
        kind: 'browsePage',
        header: {
            type: responseHeader?.type,
            title: responseHeader?.title,
            tabs: tabs?.map((tab) => ({
                ...tab,
                action: createFlowAction(
                    makeBrowsePageIntent,
                    getIntentOptionsFromActionUrl(countryCode, tab.action?.url),
                    objectGraph,
                ),
            })),
        },
        sections: transformSections(
            apiResponse?.body?.sections as any,
            objectGraph,
        ),
        canonicalURL,
        pageMetrics: createPageMetricsForResponse(
            apiResponse,
            PageType.browsePage,
        ),
    };

    return addingBrowseSeoData(canonicalURL, page, intentTab, objectGraph);
}

function getIntentOptionsFromActionUrl(countryCode: string, url?: string) {
    if (!url) {
        return {};
    }

    const queryParams = url.split('?')[1]; // Get the part after "?"
    const params = new URLSearchParams(queryParams);
    const tab = params.get('tab'); // Extract the value of "tab" parameter

    return {
        tab,
        url: `/${countryCode}/browse/${tab}`,
    };
}
